import {
  FormControlLabel,
  FormControlLabelProps,
  Switch,
  SwitchProps,
  FormHelperText,
  FormHelperTextProps,
} from "@mui/material";
import { Field, FieldProps } from "formik";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

export default function FormikSwitchField({
  name,
  label,
  helperText,
  labelProps,
  switchProps,
  helperTextProps,
}: SwitchProps & {
  name: string;
  label: string;
  helperText?: string;
  labelProps?: FormControlLabelProps;
  switchProps?: SwitchProps;
  helperTextProps?: FormHelperTextProps;
}): ReactElement {
  return (
    <>
      <FormControlLabel
        control={
          <Field name={name}>
            {({ meta, form }: FieldProps) => (
              <Switch
                sx={{
                  "+ .MuiTypography-root": {
                    color: meta.value ? palette.navy : palette.darkGray,
                  },
                }}
                color={
                  meta.error ? "secondary" : (switchProps?.color ?? "primary")
                }
                checked={!!meta.value}
                {...switchProps}
                onChange={(
                  evt: React.ChangeEvent<HTMLInputElement>,
                  checked
                ) => {
                  if (switchProps?.onChange) {
                    switchProps.onChange(evt, checked);
                    if (evt.isDefaultPrevented()) {
                      return;
                    }
                  }

                  return form.setFieldValue(name, evt.target.checked);
                }}
              />
            )}
          </Field>
        }
        label={label}
        {...labelProps}
      />
      {helperText ? (
        <FormHelperText {...helperTextProps}>{helperText}</FormHelperText>
      ) : null}
    </>
  );
}
